export default "https://d1e6s5z4lzmgxx.cloudfront.net/ba82fc54-f5ca-4442-8850-d050cbc89c21/images/sidebar-logo.png?69c8ab64fd1cfda09f22fc646c162ca4";